var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"no-wrap":"","no-fade":"","opacity":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }